function validateSignificantFigures(significantFigures: number): void {
  if (!Number.isInteger(significantFigures) || significantFigures < 1 || significantFigures > 100) {
    throw new RangeError('Significant figures must be an integer from 1 to 100.');
  }
}

export function countSignificantFigures(value: string | number): number {
  const text = String(value).trim().toLowerCase();
  if (!text || !Number.isFinite(Number(text))) throw new TypeError('Value must be a finite number.');
  const mantissa = text.split('e')[0].replace(/^[+-]/, '');
  const hasDecimal = mantissa.includes('.');
  const digits = mantissa.replace('.', '').replace(/^0+/, '');
  if (!digits) return 1;
  return hasDecimal ? digits.length : digits.replace(/0+$/, '').length || 1;
}

export function roundToSignificantFigures(value: number, significantFigures: number): number {
  validateSignificantFigures(significantFigures);
  if (!Number.isFinite(value)) throw new TypeError('Value must be finite.');
  if (value === 0) return 0;
  const magnitude = Math.floor(Math.log10(Math.abs(value)));
  const scale = 10 ** (significantFigures - 1 - magnitude);
  return Math.round((value + Math.sign(value) * Number.EPSILON * Math.abs(value)) * scale) / scale;
}

export function formatToSignificantFigures(value: number, significantFigures: number): string {
  validateSignificantFigures(significantFigures);
  if (!Number.isFinite(value)) throw new TypeError('Value must be finite.');
  return value.toPrecision(significantFigures);
}

export function significantFiguresForUncertainty(uncertainty: number): number {
  if (!Number.isFinite(uncertainty) || uncertainty <= 0) throw new RangeError('Uncertainty must be positive and finite.');
  const firstDigit = Number(uncertainty.toExponential()[0]);
  return firstDigit === 1 || firstDigit === 2 ? 2 : 1;
}